'use strict';
import axios from 'axios';
import * as qs from 'qs'
let React = require('react');
let BaseComponent = require('../../shared/base');

let Offers = require('../../../public/js/bepensa/offers');
let client = require('../../../../sdk/client');
const { data } = require('jquery');

var slick;
if (typeof window !== 'undefined') {
    slick = require('slick-carousel');
}

class SuggestedCarousel extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            arrOffers: []
        }

        this.defaultImage = "/assets/images/bepensa/cumminsNoImage.jpg";
        this.arrOfParts = [];
    }

    initCarousel() {
        $('.myoffers-carousel').slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        infinite: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }

    subFormatMoney(
        numAmount_I,
        intDecimalCount = 2,
        strDecimal = ".",
        strThousands = ","
    ) {
        try {
            intDecimalCount = Math.abs(intDecimalCount);
            intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;

            const negativeSign = numAmount_I < 0 ? "-" : "";

            let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
            let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

            return negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
                str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
                    strThousands) + (intDecimalCount ? strDecimal +
                        Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
        } catch (e) {
            //console.log(e)
        }
    }

    subToMXNCurrency(
        strPrice_I
    )
    {
        let currencyPrice = strPrice_I;
        try {
            //#exchange-currency is got from exchange-currency header.
            currencyPrice = parseFloat(strPrice_I) * $("#exchange-currency").attr("currency");
        } catch (error) {}

        return currencyPrice;
    }

    loadSalePrices() {
        //                                                  //This id is taken from the widget.
        var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");

        if (this.props.userGuest == false && (depotId != null && depotId != "")) {
            var self = this;
            let userType = this?.props?.user?.CustomFields != null ? this?.props?.user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
            let externalUserId =
                this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
            //To test: 
            //let externalUserId = {Values:["215"]};

            const priceParams = {
                deptoId: depotId,
                //MXN currency by default
                currencyCode: "MXN",
                customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                //by default order type is Offer AKA Normal
                orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : "NORMAL",
                detail: this.arrOfParts
            };

            client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams).then(response => {
                if (
                    response.Result != undefined && response.Result == 0 &&
                    response.PartsCode != undefined && response.PartsCode.length > 0
                ) {
                    response.PartsCode.forEach(function (part, index) {

                        var partNumber = part.PartCode;
                        var salePrice = null;
                        var corePrice = null;
                        if (part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null) {
                            document.getElementById('precioPublico' + partNumber).innerHTML = `<b>$ ${self.subFormatMoney(part.PartsPrices[0].PublicPrice)} MXN</b>`;
                            
                            if(userType != 'B2C') {
                                if(part.PartsPrices[0].PublicPrice != part.PartsPrices[0].SalePrice) {
                                    document.getElementById('precioPublico' + partNumber).setAttribute('style', 'text-decoration: line-through;color: red !important;');
                                    document.getElementById('precioDescuento' + partNumber).innerHTML = ` <b>$ ${self.subFormatMoney(part.PartsPrices[0].SalePrice)} MXN</b>`;
                                }
                            }

                            salePrice = part.PartsPrices[0].SalePrice;
                            if (part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null) {
                                corePrice = part.PartsPrices[0].CorePart.SalePrice
                            }

                            //If match with any item in state.arrOffers update his value
                            let indexOf = -1;
                            self.state.arrOffers.forEach((item, index) => {
                                if (item.strNumberPart == partNumber) {
                                    indexOf = index;
                                }
                            });
                            if (indexOf >= 0) {
                                self.state.arrOffers[indexOf].boolIsOverridenPrice = salePrice != null ? true : false;
                                self.state.arrOffers[indexOf].boolIsOverridenCore = corePrice != null ? true : false;
                                self.state.arrOffers[indexOf].SalePrice = salePrice || "";
                                self.state.arrOffers[indexOf].SaleCorePrice = corePrice || "";
                            }
                        }
                    });
                    self.forceUpdate();
                }
            });
        }else {
            //                                              //If not loaded yet billing-address-lider try again on the
            //                                              //      next second.
            setTimeout(() => {
                this.loadSalePrices();
            }, 1000);
        }
    }

    getPartNumbersFromCartAsArray(){
        var self = this;
        let output = [];
        let cartItems = self.props.cartItems[0];
        cartItems.forEach(function(cartItem) {
            if(cartItem.ItemDetail.CustomFields) {
	            if(cartItem.ItemDetail.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER)) {
	                let partNumber = cartItem.ItemDetail.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER).Values[0];
                    output.push(partNumber);
	            }
            }
        });

        return output;
    }

    async gatewayService(
        companyId = 446,
        clientId = 2170,
        region = "Sureste",
        warehouseId = 14,
        productList = [],
        recomendationType = 0
    ){ 
        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };
        
        const requestBody = {
            "COMPANY":companyId,
            "CLIENT":clientId,
            "REGION":region,
            "WAREHOUSE":warehouseId,
            "PRODUCTLIST":productList,
            "RECOMENDATIONTYPE":recomendationType
        };

        let gatewayRequest = {
            "strEndpointName" : "GetRecommendations",
            "strMethod" : "POST",
            "strJsonData" : requestBody
        }
        
        let response = await axios.post(APIurl, gatewayRequest, config)
            .then(response => {
                // console.log(JSON.parse(response.data));
                return JSON.parse(response.data);
            })
            .catch(error => {
                console.error(error);
                return false;
            });
            
        return response;
    }

    async getIARecommendationsNew(companyId = 446, clientId = 2170, region = "Sureste", warehouseId = 14, productList = [], recomendationType = 0){

        let recommendations = await this.gatewayService(companyId, clientId, region, warehouseId, productList, recomendationType);
        // console.log(recommendations);

        let IARecommendations = recommendations?.RecomendedProducts ? recommendations?.RecomendedProducts : null;
        // console.log(IARecommendations);
        if(!IARecommendations){
            return null;
        }

        return IARecommendations;
    }

    async renderOffers(
        boolRenderSalePrices_I = true
    ) {
        var self = this;

        var addressId = $('#address-name').attr('addressid');

        const promiseClientBoughtProducts = new Promise((resolve, reject) => {

            let parameters = {
                pluginId: process.env.ADMINISTRACION_ALMACENES, 
                tableName:"ConfiguracionUsuario", 
                query:  [{
                    "Name": "AddressId",
                    "Operator": "equal",
                    "Value": addressId//this.props.currentAddress
                }]
            };
    
            const promiseBranches = new Promise((resolve, reject) => {
    
                client.CustomTables.searchCustomTable(parameters, function (err, result) {
                    resolve(result);
                });
            });

            Promise.all([promiseBranches]).then(response => {
                let element = response[0].Records[0];
                if(element != undefined) {
                    parameters = {
                        pluginId: process.env.ADMINISTRACION_ALMACENES, 
                        tableName:"Almacenes", 
                        query:  [{
                            "Name": "Nombre",
                            "Operator": "equal",
                            "Value": element.AlmacenFacturacion
                        }]
                    };
                    
                    const promiseBranchId = new Promise((resolve, reject) => {
                        
                        client.CustomTables.searchCustomTable(parameters, function (err, result) {
                            resolve(result);
                        });
                    });
                    
                    Promise.all([promiseBranchId]).then(async response => {

                        const options = {
                            pluginId: process.env.ANALYTICS,
                            tableName: "ProductosVendidos?sort=-VecesComprado",
                            query: [
                                {
                                    "Name": "ClienteId",
                                    "Operator": "equal",
                                    "Value": self.props.user.ID // guid de arcadier
                                },
                                {
                                    "Name": "Region",
                                    "Operator": "equal",
                                    "Value": response[0].Records[0].Region
                                },
                                {
                                    "Name": "Sucursal",
                                    "Operator": "equal",
                                    "Value": response[0].Records[0].LiderId
                                }
                            ]
                        };
                        
                        let cartItemsArray = this.getPartNumbersFromCartAsArray();
                        let recommendationsType = 1;
                        if(cartItemsArray.length === 0){
                            recommendationsType = 0;
                        }                    
                        let clientId = response[0].ClienteId;//self.props.user.CustomFields.find(x=> x.Name == "Cliente ID");
                        let region = response[0].Records[0].Region;
                        let branchId = response[0].Records[0].BrachId;
                        
                        let IARecommendations = await this.getIARecommendationsNew(446, clientId, region, branchId, cartItemsArray, recommendationsType);
                        
                        if(!IARecommendations){                        
                            IARecommendations = await this.getIARecommendationsNew(446, 2170, "Sureste", 14, [], 0);
                        }

                        const searchByPartNumbers = {
                            arrNumberParts: IARecommendations
                        };

                        let itemsSearchedByPartNumbers = await client.CustomSearch.SearchAndFilterItemAsArcadierAPI(searchByPartNumbers).then(async items => {
                            let output = await items.Records;
                            // console.log(output);
                            return output;
                        });
                        // console.log(itemsSearchedByPartNumbers);
                        
                        self.setState({
                            arrOffers: itemsSearchedByPartNumbers
                        });

                        document.getElementById("ccarousel-offers").style.display = "block";

                        self.initCarousel();
            
                        // This is the deprecated function for the carousel in the cart page
                        /*
                            client.CustomTables.searchCustomTable(options, function (err, result) {
                                resolve(result);
                
                                let arrTempItems = new Array(result.Records.length);
                
                                let index = 0;
                
                                let items = result.Records;                            
                                console.log(items);
                
                                while(index < items.length){
                                    let item = items[index]
                
                                    if(self.props.cartItems[0].find(x => x.ItemDetail.CustomFields.find(y => y.Code === process.env.CF_PART_NUMBER).Values[0] === item.NumParte)){
                                        items.splice(index, 1);
                                        arrTempItems.splice(index, 1);
                                        console.log(items);
                                    } else {
                                        let itemIndex = index;
                                        const promiseProductInfo = new Promise((resolve, reject) => {
                
                                            const options = {
                                                "arrCustomFieldQueries": [
                                                    {
                                                        "Code": process.env.CF_PART_NUMBER,
                                                        "Operator": "equal",
                                                        //"Value": item.NumParte
                                                        "Value": item.NumParte
                                                    }
                                                ]
                                            }
                                            
                                            console.log(item);
                                            
                                            client.CustomSearch.CustomSearch(options).then(
                                                (response) => {
                                                    console.log(response);
                                                    
                                                    if(response.TotalRecords == 0 ){
                                                        arrTempItems[itemIndex] = {"Name": null}
                                                    } else {
                                                        arrTempItems[itemIndex] = response.Records[0];
                                                    }
                                                                                    
                                                    if(!arrTempItems.includes(undefined)){
                                                        console.log('arrTempItems');
                                                        console.log(arrTempItems);

                                                        
                                                        self.setState({
                                                            arrOffers: arrTempItems
                                                        });
                    
                                                        document.getElementById("ccarousel-offers").style.display = "block";

                                                        self.initCarousel();
                                                    }
                                                }
                                            )            
                                        });
                                        index++;
                                    }
                                }   
                            });
                        */
                    });
                }
            })
        });
    }

    componentDidMount() {
        var self = this;
        if (self.props.user != null) {
            client.Users.getUserDetails({
                excludeToken: false,
                userId: self.props.user.ID,
                includeUserCustomFields: true
            }, function (err, user) {
                if (err == null && user != null) {
                    self.props.user.CustomFields = user.CustomFields;
                    self.renderOffers();
                }
            });
        }
        else {
            self.renderOffers(false);
        }

        setTimeout(() => {
            console.log('component')
            self.loadSalePrices();
        }, 1000);

        this.getIARecommendationsNew();

        //var script = document.createElement('script');
        //script.src = "https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdy4m7CGEZn2J_2BQglMsCpraQcAqUdXkAkRmGxNZHd_2FufQ.js";
        //document.getElementById("smcx-sdk").appendChild(script);
    }

    generateSlug(itemName) {
        return itemName.replace(/[^a-zA-Z0-9\-]/g, "");
    }

    itemUrl(itemName, itemId) {
        return "/items/" + this.generateSlug(itemName) + "/" + itemId;
    }

    renderOffer(item, classPrecioCore){
        //TODO: Change hardcoded Category for reusability	
        if(item.Categories.find(x => x.ID == process.env.OFFERS) != undefined && classPrecioCore == 'hide')
        {
            return (
                <div id="container-info-offerts-carousel">
                    <div id="icon-offers">
                     	<div id="star-offers-carousel">&#10040;</div>
                        <div id="character-offers-carousel">%</div>
                    </div>
                    <div id = "offers-text-carousel">Oferta</div>
			    </div>
            ); 
 	    } 
        else if(item.Categories.find(x => x.ID == process.env.OFFERS) != undefined && classPrecioCore != 'hide') 
        {
	        return (
                <div className="store-rating item-footer-images-container">
                    <div>
                    	<div id="container-info-offerts-carousel">
                       		<div id="icon-offers">
                        	    <div id="star-offers-carousel">&#10040;</div>
                            	<div id="character-offers-carousel">%</div>
                        	</div>
                        	<div id = "offers-text-carousel">Oferta</div>
		                    <div id="icon-recon-carousel">
                            	<div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        	</div>
                        	<div id = "recon-text-carousel">Recon</div>
                    	</div>
                	</div>
                </div>
            );
	    } 
        else if(item.Categories.find(x => x.ID == process.env.OFFERS) == undefined && classPrecioCore != 'hide') 
        {
	        return (
                <div style={{ width: '100%', "textAlign": 'right' }}>
                    <div id="container-info-offerts-carousel-nooffer">
                        <div id="icon-recon-carousel">
                            <div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        </div>
                        <div id = "recon-text-carousel">Recon</div>
	                </div>
                </div>
	        );
	    }
    }

    renderCarousel() {
        var self = this;

        if(this.state.arrOffers.length > 12) {
	        this.state.arrOffers = this.state.arrOffers.slice(0, 11);
	    }
        return (<div className="myoffers-carousel carusel-sugeridos" data-slick='{"slidesToShow": 6, "slidesToScroll": 6}' style={{marginBottom:'0px'}} >

            {this.state.arrOffers.map(function (item, index) {
                var itemCF = null;
                var itemPrice = item.Price;
                var classCoreHide = "hide";
                var strPrecioCore = "";
                var strPrecioCliente = item.SalePrice;
                var boolIsOverridenPrice = item.boolIsOverridenPrice;
                var boolIsOverridenCore = item.boolIsOverridenCore;

                //css and styles to override when client price is downloaded
                var customStyleItem = {};
                var itemCSSItem = "item-name";
                var customStyleCore = {};
                var itemCSSItemCore = "item-name";

                if (item.Name == null) {
                    return(null);
                }

                if (item.CustomFields != null) {
                    itemCF = item.CustomFields.find(cf => cf.Name == "Precio Core");
                }

                if (itemCF != null && itemCF.Values[0] != "") {
                    strPrecioCore = itemCF.Values[0];
                    if(item.PriceUnit == "USD"){
                        strPrecioCore = self.subToMXNCurrency(strPrecioCore);
                    }
                    classCoreHide = "";
                }

               
                if(strPrecioCore == ""){
                    classCoreHide = "hidden-price-core"
                }

                if (boolIsOverridenPrice) {
                    customStyleItem = { color: 'red' };
                    itemCSSItem = "item-name price-real";
                }

                if (boolIsOverridenCore) {
                    customStyleCore = { color: 'red' };
                    itemCSSItemCore = "item-name price-real";
                }

                if(item.PriceUnit == "USD"){
                    itemPrice = self.subToMXNCurrency(itemPrice);
                }

                let numParte = item.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER).Values[0];

                var colorCart = 'btnaddCart btn-group btn-cart';
                var cantidadExistencia = 0;
                if(item.StockQuantity == -1) {
                    cantidadExistencia = 100;
                } else {
                    cantidadExistencia = item.StockQuantity;
                    if(cantidadExistencia == 0)
                    {     
                        colorCart += ' disabled';
                    }
                }

                var itemCorePrice = item.CustomFields.find(x => x.Code == process.env.CF_CORE_PRICE).Values[0];
                var strPartCode = item.CustomFields.find(x => x.Code === process.env.CF_PART_NUMBER).Values[0];

                var classPrecioCore = '';
                var classNumeroParte = '';
                if(itemCorePrice == 0) {
                    classPrecioCore = 'hide';
                }

                if(item.Name.includes(strPartCode)){
                    classNumeroParte = 'hide';
                }

                const requestBody = {
                    "operatingUnitId": 446,
                    "partsCode": [{
                        "partCode": numParte
                    }]
                };
                
                const promiseapilider = client.Availability.GetAvalability(requestBody);
                Promise.all([promiseapilider]).then(response => {
                    let avalabilityes = response[0].Parts[0].Availabilitys;
                    let avalabilityesTotal = 0;
                    
                    avalabilityes.forEach(element => {
                        avalabilityesTotal = element.Availability+avalabilityesTotal;
                    })

                    var colorCart = 'btnaddCart btn-group btn-cart';

                    if(avalabilityesTotal == 0) {     
                        colorCart += ' disabled';
                        if(typeof window !== 'undefined') {
                            if(document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode)) {
                                document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).className = colorCart;
                                document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).innerHTML = `<label>Comprar</label>`; 
                            }
                        }
                    } else {
                        if(typeof window !== 'undefined') {
                            if (document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode)) {
                                document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).className = colorCart;
                            }
                        }
                    }

                    if(typeof window !== 'undefined') {
                        if(document.getElementById("existenciasSearch" + response[0].Parts[0].PartCode)) {
                            document.getElementById("existenciasSearch" + response[0].Parts[0].PartCode).innerText = avalabilityesTotal;
                        }
                    }
                });

                return (
                    <div key={/*item.ID*/index} className="col-md-2 col-sm-4 col-xs-6"  style={{marginBottom: '50px'}}>
                        <a href={self.itemUrl(item.Name, item.ID)} className="item-box-small item-suggested-carousel">
                            <div className="item-image" id="img-carousel">
                                <img src={item.Media != null && item.Media.length > 0 ? item.Media[0].MediaUrl : self.defaultImage}
                                    alt={item.Name} title={item.Name} className="img-responsive" />
                            </div>
                        </a>
                        <div className="item-detail" >
                            <p className={"item-name " + classNumeroParte}>{numParte}</p>
                            <p className="item-name">{item.Name}</p>
                            <div>Existencias: <label id={"existenciasSearch" + numParte}>{cantidadExistencia}</label>
                            </div>
                            <div className={{ colorCart }}
                                style={{padding: "5px", fontSize: "12px" }}
                                id={"cartExistenciasSearch" + numParte}>
                                <a href="#" onClick= {() => self.handleAddClick(item.ID)}>Comprar</a>
                            </div>
                            <div className="item-price" style={{paddingTop: "10px"}}>
                                <div>
                                    <span id={"precioPublico" + numParte}><b>$ {self.subFormatMoney(itemPrice)} MXN</b></span><br/>
                                    <span id={"precioDescuento" + numParte}></span>
                                </div>
                                {self.renderOffer(item, classPrecioCore)}
                                <label className={classPrecioCore} style={{ fontSize: '12px'}}>Precio CORE: $ {self.subFormatMoney(strPrecioCore)/*self.renderFormatMoney("MXN", itemCorePrice)*/} MXN</label>
                            </div>
                        </div>        
                    </div>
                );
            })}
        </div>
        )
    }

    handleAddClick(itemId) {

        var userGuid = this.props.user.ID;

        const options = {
            userId: userGuid,
            quantity: 1,
            discount: "",
            itemId: itemId,
            force: false,
            forComparison: false
        };

        $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Agregando producto al carrito, por favor espere...' });

        var promiseCart = new Promise((resolve, reject) => {
            client.Carts.addCart(options, function (err, result) {
                if (err) {
                    if (err.toString().includes('Insufficient stock')) {
                        reject({ Code: 'INSUFFICIENT_STOCK' });
                    }

                    if (err.toString().includes('Invalid service booking')) {
                        reject({ Code: 'INVALID_SERVICE_BOOKING' });
                    }
                }
                else {
                    resolve(result);
                    console.log("##" + result);
                }
            });
        });

        Promise.all([promiseCart]).then((responses) => {
            window.location.reload();
        });
        (err) => {

        }
    }

    getCellFooterImages(
        classCoreHide_I
    )
    {
        let returnFooter = (<div></div>);
        if(classCoreHide_I != undefined){
            if(classCoreHide_I == "hide"){
                returnFooter = (
                    <div className="store-rating item-footer-images-container">
                        <img alt="oferta" src="/assets/images/bepensa/oferta.png" />
                    </div>
                );
            }else{
                returnFooter = (
                    <div className="store-rating item-footer-images-container">
                        <img className="item-footer-image" alt="oferta" src="/assets/images/bepensa/oferta.png" />
                        <img className="item-footer-image" alt="recon" src="/assets/images/bepensa/recon.png" />
                    </div>
                );
            }
        }

        return returnFooter;
    }

    render() {
        return (
            <React.Fragment>
                <div className="" id="ccarousel-offers" style={{display:"none",marginBottom: "5vh"}}>
                    <div className="bp-section-title"><h3>¿Olvidas algo?</h3></div>
                    {this.renderCarousel()}
                </div>
                {/*<div style={{ marginLeft: '25px'}}>
                    <a href="/search?keywords=&categories=" + process.env.OFFERS style={{color: 'black'}}>
                        <h3 id="mitexto">Ver más &#10132;</h3>
                    </a>
                </div>*/}
            </React.Fragment>
        );
    }
}

module.exports = SuggestedCarousel;